import './instrument';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import ErrorBoundary from '@components/ErrorBoundary';
import { queryClient } from '@hooks/queryClient';
import { initI18n } from '@i18n/index';
import { resolveLocale } from '@i18n/resolveLocale';
import App from './App';
import './index.css';

const { locale, redirectTo } = resolveLocale(
  window.location.pathname,
  window.location.search,
  navigator.languages,
);

if (redirectTo) {
  window.location.replace(redirectTo);
} else {
  initI18n(locale);
  document.documentElement.lang = locale;

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter basename={`/${locale}`}>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </BrowserRouter>
      </QueryClientProvider>
    </React.StrictMode>,
  );
}
